export const LIST_DOMAIN_EXIST = ["https://meeting.atviettelsolutions.com",
    "https://meetingcloud.atviettelsolutions.com",
    "https://testmeeting.atviettelsolutions.com",
    "https://viettelmeeting.atviettelsolutions.com",
    "https://viettelmeetingtest.atviettelsolutions.com",
    "https://testboard.atviettelsolutions.com",
    "https://meet.viettelmeeting.vn",
    "https://ops.viettelmeeting.vn",
    "https://license.atviettelsolutions.com"
]

export const DOMAIN_AUTO_LOGIN = {
    VIETTEL_CLOUD: 'viettel-cloud',
    GOOGLE: 'google',
    SME: 'sme'
}

export const LIST_DOMAIN_AUTO_LOGLIN = Object.values(DOMAIN_AUTO_LOGIN)
